<template>
    <div class="section" dir="rtl">
        <div class="container">
            <div class="breadcrumb mb-10 text-bold" id="biography" > {{  $t('header.publications.title') }} > {{ $t('header.publications.journal.title') }}</div>
        </div>
    </div>

    <div class="container" dir="rtl" >
        <div class="title">دفاتر النزاهة و الشفافية </div>

        <div class="row mb-5">
            <div class="px-lg-5 ressource mt-5 mb-2">
                <div class="container d-flex pb-5 card-bloc">

                    <div class="card-group row">
                        <div class="cadre col-md-12 col-lg-6 px-xl-5">
                            <div class="cadre__inner">
                                <a :href="'pdf/publications/دفاتر النزاهة و الشفافية.pdf'" download target="_blank" > <font-awesome-icon class="fa-2x" icon="fa fa-download fa-2x" />&nbsp; </a>
                                <a :href="'pdf/publications/دفاتر النزاهة و الشفافية.pdf'" target="_blank">دفاتر النزاهة و الشفافية</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "journal"
    }
</script>

<style scoped>
    ul.no-bullets {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    .mot_president{
        color: rgba(50, 54, 57, 0.83);
    }
    .nav-link{
        color: rgba(80, 84, 87, 0.8) !important;
    }
    .active{
        color: rgba(28, 28, 28, 0.96)!important;
    }
    .section {
        display: flex;
        align-items: center;
        font-size: var(--xs-font-size);
        font-weight: bold;
        background: var(--secondary-background-color);
        padding: calc(7/16 * var(--default-size-unit)) calc((100vw - 1920px)/2 +  var(--body-padding));
        border-top: var(--input-border);
        border-bottom: var(--input-border);
        font-family: Cairo,sans-serif;
    }
    .breadcrumb{
        text-decoration: none!important;
        margin: 0;
        color: #37414D;
        font-family: Cairo,sans-serif!important;
    }
    .title {
        width: 100%;
        display: flex;
        align-items: center;
        font-size: var(--l-font-size);
        font-weight: 700;
    }
    .title::before {
        content: ' ';
        display: block;
        -webkit-margin-end: var(--default-size-unit);
        margin-inline-end: var(--default-size-unit);
        width: calc(35/16 * var(--default-size-unit));
        height: calc(8/16 * var(--default-size-unit));
        background: var(--primary-text-color);
        min-width: calc(35/16 * var(--default-size-unit));
    }
    .back-gray{
        background-color: #E7E9EB;
        padding: 15px 15px;
    }
    .back-gray p{
        line-height: 200%;
    }
    .card-bloc{
        box-shadow: 5px 5px 30px #5a6268;
        min-height: 400px;
        justify-content: center;
        flex-direction: column-reverse
    }

    .card-group .cadre .cadre__inner{
        background-color: rgb(152, 187, 89);
        /*margin: 10px 20px;*/
        margin-top: 20px;
        box-shadow: 5px 5px 20px #051a27;
        height: 120px;
        /*padding-top: 20px;*/
        border-radius: 4px;
        display: flex;
        align-content: space-between;
        justify-content: space-between;
        padding-left: 15px;
        padding-right: 15px;
    }
    .card-group .cadre .cadre__inner a{
        padding:7px 15px;
        color: #0e1014 !important;
        font-weight: bold!important;
        font-size:var(--m-font-size);
        text-decoration: none;
        text-shadow: 0 0 5px rgb(250, 250, 250);
    }
    .card-group .cadre .cadre__inner a:hover,.card-group .cadre .cadre__inner i:hover{
        color: black !important;
        font-weight: bold;
        text-shadow: 0 2px 2px rgb(250, 250, 250);


    }
    .card-group .cadre .cadre__inner i{
        color:gray;
        vertical-align: middle;
        box-shadow: 5px 5px 10px #000000;

    }
    .cadre__inner{
        direction: ltr;
    }
    .card-group{
        padding-top: auto;
        padding-bottom: auto;
    }
    @media(max-width: 415px){
        .card-bloc{
            box-shadow: 5px 5px 30px #5a6268;
            /*height: 500px;*/
            justify-content: center;
            flex-direction: column-reverse
        }

        .card-group .cadre .cadre__inner{
            padding-top: 7px!important;
            height: 140px !important;
            padding-left: 5px;
            padding-right: 5px;
        }
        .cadre__inner a{
            padding-left: 5px;
            padding-right: 5px;
            line-height: 1.3;
            font-size: var(--s-font-size);
        }
    }
</style>